import { Printer } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useLang } from "@/i18n";
import { LogoMark } from "./Logo";

export const SpecSheet = ({ open, onOpenChange, k }) => {
  const { t } = useLang();
  const s = t.services.items[k];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="spec-sheet-modal" className="max-w-2xl bg-[#0D0D10] border-white/10 rounded-none p-0 overflow-hidden" data-lenis-prevent>
        <div className="h-1 bg-gradient-to-r from-red-900 via-red-600 to-red-900" />
        <div className="p-7 sm:p-9">
          <DialogHeader className="text-left">
            <div className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.25em] text-red-500"><LogoMark className="h-6 w-6" />{t.services.sheet} · AD-{k.toUpperCase()}</div>
            <DialogTitle className="font-display font-extrabold uppercase text-3xl text-white mt-4">{s.title}</DialogTitle>
            <DialogDescription className="text-zinc-300">{s.desc}</DialogDescription>
          </DialogHeader>
          <table className="w-full mt-6 text-sm" data-testid="spec-sheet-table">
            <tbody>
              {s.specs.map(([a, b]) => (
                <tr key={a} className="border-b border-white/10">
                  <td className="py-3 pr-4 font-mono text-xs uppercase tracking-widest text-zinc-400 w-2/5">{a}</td>
                  <td className="py-3 text-white">{b}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="mt-6 text-sm text-zinc-400 leading-relaxed">{t.services.sheetNote}</p>
          <button data-testid="spec-sheet-print-button" onClick={() => window.print()} className="mt-6 clip-btn inline-flex items-center gap-2 border border-white/20 hover:border-red-500 transition-colors px-5 py-3 font-mono text-xs uppercase tracking-[0.16em] text-white"><Printer className="h-4 w-4" />{t.services.print}</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
